import { styled } from "styled-system/jsx";
import { SystemStyleObject } from "styled-system/types";

export const DashedCircle = ({ ...props }: SystemStyleObject) => {
  return (
    <styled.svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_884_2960)">
        <circle
          cx="8.00004"
          cy="8.00016"
          r="6.66667"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="3 3"
        />
      </g>
      <defs>
        <clipPath id="clip0_884_2960">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </styled.svg>
  );
};
